import { DetailActivity, DetailTitle, Layout, MTools, Player, Share } from '@/components';
import WazBreadcrumb from '@/components/Breadcrumb';
import { imagePrefix } from '@/constants';
import { IActivity } from '@/models/types/activity';
import { getActivityDetail, getTopicRecommend } from '@/services/api';
import { getQuery } from '@/utils/tool';
import { RouteComponentProps, withRouter } from 'dva/router';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import styles from './detail.less';

interface ITopicDetailProps {

}

const TopicDetail: React.FC<ITopicDetailProps & RouteComponentProps<{ id: string }>> = ({ match, history }) => {
  const topicId = match.params.id;
  const [data, setData] = useState<IActivity>()
  const [list, setList] = useState<IActivity[]>([])
  const query: any = getQuery() || {}

  useEffect(() => {
    getData()
    getList()
    window._czc?.push(["_trackEvent", query?.type === '1' ? 'course' : 'wk', topicId])
  }, [topicId])

  const getData = async () => {
    const result = await getActivityDetail(topicId)
    if (result.success) {
      setData(result.data)
    } else {
      MTools.Tips('error', (result && (result.message)) || '系统异常，请刷新再试')
    }
  }

  const getList = async () => {
    const result = await getTopicRecommend(topicId)
    if (result.success) {
      setList(result.data)
    } else {
      MTools.Tips('error', (result && (result.message)) || '系统异常，请刷新再试')
    }
  }

  return (
    <div className={styles.index}>
      <Layout
        padding={0}
      >
        <div
          className={styles.content}
          style={{
            backgroundImage: `url(${imagePrefix('detail-bgc.png')})`
          }}
        >
          <div className={styles.breadcrumb}>
            <WazBreadcrumb
              data={[{
                title: query?.typeTitle || '',
                link: `/app/topic/${query?.type}`
              }, {
                title: query?.type === '1' ? '云课堂详情页' : '微课详情页'
              }]}
            ></WazBreadcrumb>
          </div>
          <div className={styles.title}>
            {data?.title}
          </div>
          <div className={styles.author}>
            {query?.type == 2 ? '作者' : '主讲人'}: {data?.vipId?.replace(/,/ig, ' ')}
          </div>
          <div className={styles.player}>
            <div className={styles.playerContent}>
              {
                data?.url ?
                  <Player poster={data?.cover} url={data?.url} /> : null
              }
            </div>
          </div>
        </div>
        {query?.type === '1' && data?.summary && <div className={styles.info}>
          <DetailTitle title='课程介绍'></DetailTitle>
          <div className={styles.text}>
            {data.summary}
          </div>
        </div>}
        <div className={styles.list}>
          {list.filter(item => item.id !== topicId).slice(0, 4).map(item => {
            return (
              <div
                className={styles.item}
                key={item.id}
                onClick={() => {
                  history.push(`/app/topic/detail/${item.id}?type=${query?.type}&typeTitle=${query?.typeTitle}`)
                }}
              >
                <div className={styles.left}>
                  <div className={styles.title}>
                    {item.title}
                  </div>
                  <div className={styles.author}>
                    {query?.type == 2 ? '作者' : '主讲人'}: {item.vipId?.replace(/,/ig, ' ')}
                  </div>
                </div>
                <div className={styles.right}>
                  <div className={styles.cover}
                    style={{
                      backgroundImage: `url(${item.cover})`
                    }}
                  >
                    <div className={styles.btn}></div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
        <div
          className={styles.more}
          onClick={() => {
            history.push(
              `/app/topic/${query?.type}`
            )
          }}
        >
          {query?.type === '1' ? '更多云课堂' : '更多微课'}
          <img src={imagePrefix('detail-arrow-more.png')} alt="" />
        </div>
        <div className={styles.detailActivity}>
          <DetailActivity></DetailActivity>
        </div>
      </Layout>
      <Share businessId={topicId} businessType={2} />
    </div>
  );
};

export default withRouter(TopicDetail);;